// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/blog/:slug\",\"regex\":\"^/blog/([^/]+)$\",\"paramNames\":[\"slug\"]},{\"path\":\"/docs/:category/:slug\",\"regex\":\"^/docs/([^/]+)/([^/]+)$\",\"paramNames\":[\"category\",\"slug\"]}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/about\"},{\"path\":\"/blog\"},{\"path\":\"/changelog\"},{\"path\":\"/compare/github-hosted-macos-runners-vs-getmac\"},{\"path\":\"/contact\"},{\"path\":\"/cookie-policy\"},{\"path\":\"/docs\"},{\"path\":\"/faq\"},{\"path\":\"/github-runners\"},{\"path\":\"/help\"},{\"path\":\"/infrastructure\"},{\"path\":\"/pricing\"},{\"path\":\"/privacy-policy\"},{\"path\":\"/subprocessors\"},{\"path\":\"/terms-of-service\"}]}";globalThis["_sentryNextJsVersion"] = "15.5.2";import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: "https://b3181de509a760e4bf6b7593379e6bce@o4508868166615040.ingest.us.sentry.io/4509968860774400",

  // Add optional integrations for additional features
  integrations: [Sentry.replayIntegration()],

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,
  // Enable logs to be sent to Sentry
  enableLogs: true,

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
